import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { EspecialidadeVeiculoService } from '../services/especialidade-veiculo.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-especialidade-veiculo-edit',
	templateUrl: './especialidade-veiculo-edit.component.html',
	styleUrls: ['./especialidade-veiculo-edit.component.css'],
	animations: [loadingFade]
})
export class EspecialidadeVeiculoEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public especialidade_veiculo_id = null;

	public formEspecialidadeVeiculo: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private especialidadeVeiculoSvc: EspecialidadeVeiculoService,
				private router: Router) { }

	ngOnInit() {
		this.criaForm();

		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.especialidade_veiculo_id = params.id;
				// pega dados a partir do id
				this.especialidadeVeiculoSvc.getEspecialidadeVeiculo(params.id).then((data: any) => {
					this.preencheForm({
						especialidade_veiculo_id: data.especialidade_veiculo_id,
						especialidade_veiculo_nome: data.especialidade_veiculo_nome,
						especialidade_veiculo_sigla: data.especialidade_veiculo_sigla
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formEspecialidadeVeiculo = this.fb.group({
			especialidade_veiculo_id: null,
			especialidade_veiculo_nome: ['', Validators.required],
			especialidade_veiculo_sigla: ['', Validators.required]
		});
	}

	preencheForm(dados) {
		this.formEspecialidadeVeiculo.setValue(dados);
	}

	enviaEspecialidadeVeiculo() {
		if (this.formEspecialidadeVeiculo.valid) {
			this.submitting = true;

			let toSend = this.formEspecialidadeVeiculo.value;

			if (this.especialidade_veiculo_id === null) { // criar
				this.especialidadeVeiculoSvc.criaEspecialidadeVeiculo(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Especialidade de veículo criada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/especialidadesveiculo']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.especialidadeVeiculoSvc.editaEspecialidadeVeiculo(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Especialidade de veículo alterada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/especialidadesveiculo']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formEspecialidadeVeiculo.controls){
				let campo = this.formEspecialidadeVeiculo.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formEspecialidadeVeiculo.get(nome);
		return input.touched && input.invalid;
	}
}
